import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=1034abce&"
import script from "./VHeader.vue?vue&type=script&lang=ts&"
export * from "./VHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VHeader.vue?vue&type=style&index=0&id=1034abce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports